import React, { useEffect, useState } from 'react';
import './EditUpload.css';

const EditCategoryUploadBox = ({ label, onFileChange, defaultValue }) => {
    const [previewUrl, setPreviewUrl] = useState(defaultValue);

    const handleFileChange = (event) => {
      const file = event.target.files[0];
      if (file) {
        setPreviewUrl(URL.createObjectURL(file));
        if (onFileChange) {
          onFileChange(file);
        }
      }
    };
    return (
    //   <div className="upload-box-container">
    //     <label className="upload-label fts-15 common-text ftw-4 lt-gray">{label}</label>
    //     <div className="upload-box">
    //       <input
    //         type="file"
    //         onChange={handleFileChange}
    //         className="upload-input"
    //         id="file-upload"
    //       />
    //       <label
    //         htmlFor="file-upload"
    //         className="upload-placeholder common-text blue fts-15 ftw-4"
    //       >
    //         <div className="upload-icon-country">
    //           {previewUrl ? (
    //             <img
    //               src={previewUrl}
    //               alt="Selected or Existing Country Flag"
    //               className="existing-image"
    //             />
    //           ) : (
    //             <span className="common-text blue fts-13 ftw-4">Browse File</span>
    //           )}
    //         </div>
    //       </label>
    //     </div>
    //   </div>

        <div className="upload-box-container">
        <label className="upload-label fts-15 common-text ftw-4 lt-gray">{label}</label>
        <div className="upload-box">
        <input
            type="file"
            onChange={handleFileChange}
            className="upload-input"
            id="file-upload"
            // accept="image/jpeg,image/png,image/svg+xml"
        />
        <label
            htmlFor="file-upload"
            className="upload-placeholder common-text blue fts-15 ftw-4"
        >
            <div className="upload-icon">
            {previewUrl ? (
                <img
                src={previewUrl}
                alt="Selected Profile Picture"
                className="round-img"
                />
            ) : (
                <span className="common-text blue fts-13 ftw-4">Browse File</span>
            )}
            </div>

        </label>
        </div>
        </div>      
    );
  };
  
  export default EditCategoryUploadBox;